<ngx-spinner bdColor="rgba(0,0,0,0.4)" size="large" color="#fff" type="ball-scale-multiple" [fullScreen]="true">
  <!-- <h5 class="spinnercolor">Loading['..</h5> -->
</ngx-spinner>
<nav class="navbar header-navbar pcoded-header zIndex" *ngIf="!showloginheader">
  <!-- <div class="navbar-wrapper">
    <div class="navbar-logo navbarlogo" data-navbar-theme="theme4">
      <div>
        <img src="assets/images/gsklogonew.png" class="topLogo" alt="GSK"><br />
        <img src="assets/images/Orenge-Logo.png" class="textLogo" alt="VaxiKart">
      </div>
      
      <a class="mobile-options" (click)="showLogout()" style="width: 133px;height: 50px;">
        <i class="ti-more"></i>
        <img src="assets/images/m-profile.svg" alt="User-Profile-Image">
        <div *ngIf="showLogoutpopover" @slideInOut class="show-notification">
          <button type="submit" (click)="logout()" class="submitbtn">
            <i class="ti-layout-sidebar-left"></i>
            Logout
          </button>
        </div>
      </a>
    </div>

    <div class="navbar-container container-fluid" >
      <div style="display: flex;
          align-items: center;
          height: 100%;
          width: 100%;justify-content: space-between;">
        <h4 class="nav-left headertitle">KYC Portal</h4>
        <ul class="nav-right">
          <li class="user-profile header-notification">
            <a>
              <img src="assets/images/m-profile.svg" alt="User-Profile-Image">
              <span class="blackColor"> Welcome </span>
              <span *ngIf="Name!=='undefined'" class="blackColor"> {{Name}}</span>
              <i class="ti-angle-down"></i>
            </a>
            <ul class="show-notification profile-notification">
              <li>
                <button type="submit" (click)="logout()" class="text-inverse forgetButton"> Logout</button>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      
    </div>
  </div> -->
  <div class="navbar-wrapper">
    <div class="navbar-container">
      <div class="navbar-left">
        <img src="assets/images/gsklogonew.png" class="topLogo" alt="GSK">
        <br>
        <img src="assets/images/Orenge-Logo.png" class="textLogo" alt="VaxiKart">
      </div>
      <div class="navbar-center" *ngIf="!hideNavbarCenter">
        <h4 *ngIf="currentPageTitle === 'KYC Portal'" class="headertitle">KYC Portal</h4>
        <h4 *ngIf="currentPageTitle === 'POB Portal'" class="headertitle" class="headertitle">POB Portal</h4>
      </div>
      <!-- <div class="navbar-right">
        <div class="profile-menu" (click)="showLogout()">
          <img src="assets/images/m-profile.svg" alt="User-Profile-Image" class="profile-icon">&nbsp;
          <span class="blackColor profile-name">Welcome &nbsp;</span>
          <span *ngIf="Name !== 'undefined'" class="blackColor profile-name"> {{ Name }} &nbsp;</span>
          <i class="ti-angle-down"></i>
        </div>
        <ul class="profile-dropdown" *ngIf="showLogoutpopover">
          <li>
            <button type="submit" (click)="logout()" class="logout-btn">Logout</button>
          </li>
        </ul>
      </div> -->
    </div>
  </div>

  <div *ngIf="!isMobileView"
    style="width: 100%;border: 1px solid #f16c3d;height:40px;background-color: #f16c3d;display: flex;align-items: center;justify-content:space-between;">
    <table>
      <tr>
        <td class="Selectedpage">
          <mat-icon (click)="goBack()" *ngIf="showHeader && userRole !== 'REP_KYC'">arrow_back</mat-icon>&nbsp;&nbsp;
          <mat-icon (click)="goBack()"
            *ngIf="hidebackbtn=='N' && userRole == 'USER_KYC'">arrow_back</mat-icon>&nbsp;&nbsp;
          {{pageName}}
        </td>
      </tr>
    </table>
    <table>
      <tr>
        <td class="td" (click)="Home()" *ngIf="userRole === 'REP_ALL' && currentPage !== 'homepage'">
          <div class="tddiv">
            <mat-icon>home</mat-icon> &nbsp; Home
          </div>
        </td>
        <td class="td" (click)="hcpSelection()"
          *ngIf="(userRole === 'REP_POB' || userRole === 'REP_ALL') && !isPOBPage() && currentPage !== 'homepage' && currentPage !== 'repkycdashboard'">
          <div class="tddiv">
            <mat-icon>dashboard</mat-icon> &nbsp; HCP Selection
          </div>
        </td>

        <td class="td" (click)="Pobdashboard()"
          *ngIf="(userRole === 'REP_POB' || userRole === 'REP_ALL') && isPOBPage()">
          <div class="tddiv">
            <mat-icon>dashboard</mat-icon> &nbsp; POB Dashboard
          </div>
        </td>
        <!-- <td class="td" (click)="Kycdashboard()"
          *ngIf="(userRole === 'REP_KYC' || userRole === 'REP_ALL') && isKYCPage()">
          <div class="tddiv">
            <mat-icon>dashboard</mat-icon> &nbsp; KYC Dashboard
          </div>
        </td> -->
        <td class="td" (click)="logout()">
          <div class="tddiv">
            <mat-icon>logout</mat-icon> &nbsp; Logout
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div *ngIf="isMobileView" class="mobile-dropdown"
    style="width: 100%;border: 1px solid #f16c3d;height:40px;background-color: #f16c3d;display: flex;align-items: center;justify-content:space-between;">
    <button class="menubtn" mat-button [matMenuTriggerFor]="mobileMenu" (click)="openMenu(mobileMenuTrigger)"
      #mobileMenuTrigger="matMenuTrigger">
      <!-- Hamburger icon -->
      <mat-icon style="color: white;">menu</mat-icon>
    </button>

  </div>
  <!-- Angular Material Menu -->
  <mat-menu #mobileMenu="matMenu">
    <button mat-menu-item *ngIf="userRole === 'REP_ALL' && currentPage !== 'homepage'"
      (click)="Home()"><mat-icon>home</mat-icon> &nbsp;
      Home</button>
    <button mat-menu-item
      *ngIf="(userRole === 'REP_POB' || userRole === 'REP_ALL') && !isPOBPage() && currentPage !== 'homepage' && currentPage !== 'repkycdashboard'"
      (click)="hcpSelection()"><mat-icon>dashboard</mat-icon> &nbsp; HCP
      Selection</button>

    <button mat-menu-item *ngIf="(userRole === 'REP_POB' || userRole === 'REP_ALL') && isPOBPage()"
      (click)="Pobdashboard()"><mat-icon>dashboard</mat-icon> &nbsp; POB
      Dashboard</button>
    <!-- <button mat-menu-item *ngIf="showKycDashboard" (click)="Kycdashboard()"><mat-icon>dashboard</mat-icon> &nbsp; KYC
      Dashboard</button> -->
    <button mat-menu-item (click)="logout()">
      <mat-icon>logout</mat-icon> &nbsp; Logout
    </button>
  </mat-menu>
</nav>